import React from 'react';
const customers = [{
  name: 'Hextronics',
  logo: 'https://cdn.magicpatterns.com/uploads/tLqmB97x3XUkkMnz4Qsu5F/hex-png.png',
  href: 'https://www.hextronics.com/'
}, {
  name: 'Octo Server',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uki8u29T2nAj9aWWE68ScR/octoserver_dark.png',
  href: 'https://www.octoserver.com/'
}, {
  name: 'Crossbow Systems',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fpZ38CxWMVGvw2t9cmUgRp/xbow_dark.png',
  href: 'http://crossbowsystems.net/'
}, {
  name: 'FREDsense',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2NxyvG5yHavGA567Kq28Un/fredsense_dark.png',
  href: 'https://fredsense.com/'
}, {
  name: 'Flight Deck Solutions',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hAE2QJNs6DvEe9k3x67t5B/logo.png',
  href: 'https://flightdecksolutions.com/'
}, {
  name: 'N Line Energy',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5HQwJJtXU5yt9hecifgVSW/nline_dark.png',
  href: 'https://nlineenergy.com/'
}, {
  name: 'Blissway',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/frH9B3w3M8vQmPVXXcg75h/blissway_dark.png',
  href: 'https://www.blissway.com/'
}, {
  name: 'Flexxbotics',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mU8u7pBeiVDbQpmpXoKRiL/flexxbotics_dark.png',
  href: 'https://flexxbotics.com/'
}, {
  name: 'Aclarity',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wbpXt4jqn1FfCvHhFwJUUi/aclarity.png',
  href: 'https://aclarity.com/'
}];
export function CustomerLogos() {
  // Duplicate the list for seamless infinite scroll
  const allLogos = [...customers, ...customers];
  return <section className="relative w-full bg-navy pt-4 pb-8 overflow-hidden" data-id="element-99">
      {/* Top subtle divider */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2/3 h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" data-id="element-100" />

      <p className="text-center text-white/30 text-sm font-medium tracking-[0.2em] uppercase mb-10" data-id="element-101">
        Trusted by innovative companies
      </p>

      {/* Marquee container */}
      <div className="relative" data-id="element-102">
        {/* Left fade */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-navy to-transparent z-10 pointer-events-none" data-id="element-103" />
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-navy to-transparent z-10 pointer-events-none" data-id="element-104" />

        <div className="flex animate-marquee" data-id="element-105">
          {allLogos.map((customer, index) => <a key={`${customer.name}-${index}`} href={customer.href} target="_blank" rel="noopener noreferrer" className="flex-shrink-0 mx-12 flex items-center justify-center group" data-id="element-106">
              <img src={customer.logo} alt={customer.name} className="h-16 w-auto max-w-[240px] object-contain transition-all duration-300 cursor-pointer" style={{
            filter: customer.name === 'Hextronics' ? 'brightness(0) invert(1) opacity(0.4)' : 'brightness(0) invert(1) opacity(0.4)'
          }} onMouseEnter={e => {
            e.currentTarget.style.filter = 'brightness(0) invert(1) opacity(1) drop-shadow(0 0 12px rgba(255,255,255,0.4))';
          }} onMouseLeave={e => {
            e.currentTarget.style.filter = customer.name === 'Hextronics' ? 'brightness(0) invert(1) opacity(0.4)' : 'brightness(0) invert(1) opacity(0.4)';
          }} data-id="element-107" />
            </a>)}
        </div>
      </div>

      {/* Bottom subtle divider */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-2/3 h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" data-id="element-108" />
    </section>;
}